import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const TL = (v) => new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',minimumFractionDigits:0}).format(v||0);

const KAT = {
  kitap_seti:      { label:'Kitap Seti',      icon:'📚', color:'#3B82F6' },
  deneme_sinavi:   { label:'Deneme Sınavı',   icon:'📝', color:'#8B5CF6' },
  kirtasiye:       { label:'Kırtasiye',       icon:'✏️',  color:'#F59E0B' },
  teknik_malzeme:  { label:'Teknik Malzeme',  icon:'🔧', color:'#6B7280' },
  diger:           { label:'Diğer',            icon:'📦', color:'#94A3B8' },
};

// Mobil uyumluluk için yardımcı stil objesi
const mobileStyles = `
  @media (max-width: 768px) {
    .modal { width: 95% !important; margin: 10px !important; padding: 15px !important; max-height: 90vh; overflow-y: auto; }
    .responsive-grid { grid-template-columns: 1fr !important; }
    .section-header { flex-direction: column; align-items: flex-start !important; gap: 15px; }
    .section-header button { width: 100%; }
    .tab-container { flex-wrap: wrap; }
    .tab-container button { flex: 1; font-size: 0.8rem; padding: 8px 4px !important; }
    .filter-bar { flex-direction: column; align-items: stretch !important; }
    .filter-bar select { width: 100% !important; }
    
    /* Tabloyu mobilde kart yapısına çevirme */
    .table-container table, .table-container thead, .table-container tbody, .table-container th, .table-container td, .table-container tr { 
      display: block; 
    }
    .table-container thead tr { position: absolute; top: -9999px; left: -9999px; }
    .table-container tr { border: 1px solid var(--border); margin-bottom: 10px; border-radius: 8px; padding: 8px; background: var(--bg-card); }
    .table-container td { border: none; position: relative; padding-left: 50% !important; text-align: right !important; min-height: 30px; display: flex; align-items: center; justify-content: flex-end; }
    .table-container td:before { content: attr(data-label); position: absolute; left: 10px; width: 45%; padding-right: 10px; white-space: nowrap; text-align: left; font-weight: bold; color: var(--text-secondary); }
    .mobile-actions { justify-content: flex-end; width: 100%; margin-top: 10px; border-top: 1px solid var(--border); padding-top: 10px; }
  }
`;

function KalemModal({ kalem, onSave, onClose }) {
  const [form, setForm] = useState(kalem || {
    ad:'', kategori:'diger', birim:'adet', birim_maliyet:'', satis_fiyati:'',
    stok_miktari:'0', kritik_stok:'5', kod:'',
  });
  const [saving, setSaving] = useState(false);
  const handleSubmit = async () => {
    if (!form.ad) { toast.error('Ürün adı zorunlu'); return; }
    setSaving(true);
    try { await onSave(form); } finally { setSaving(false); }
  };
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <style>{mobileStyles}</style>
      <div className="modal" style={{maxWidth:540, width:'100%'}} onClick={e=>e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">{kalem ? '✏️ Kalem Düzenle' : '+ Yeni Stok Kalemi'}</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="responsive-grid" style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
          <div className="form-group" style={{gridColumn:'1/-1'}}>
            <label className="form-label">Ürün Adı *</label>
            <input className="form-input" value={form.ad} onChange={e=>setForm(f=>({...f,ad:e.target.value}))} />
          </div>
          <div className="form-group">
            <label className="form-label">Kategori</label>
            <select className="form-input" value={form.kategori} onChange={e=>setForm(f=>({...f,kategori:e.target.value}))}>
              {Object.entries(KAT).map(([v,k]) => <option key={v} value={v}>{k.icon} {k.label}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Birim</label>
            <select className="form-input" value={form.birim} onChange={e=>setForm(f=>({...f,birim:e.target.value}))}>
              <option value="adet">Adet</option><option value="set">Set</option>
              <option value="paket">Paket</option><option value="kutu">Kutu</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Maliyet (₺)</label>
            <input className="form-input" type="number" value={form.birim_maliyet} onChange={e=>setForm(f=>({...f,birim_maliyet:e.target.value}))} />
          </div>
          <div className="form-group">
            <label className="form-label">Satış Fiyatı (₺)</label>
            <input className="form-input" type="number" value={form.satis_fiyati} onChange={e=>setForm(f=>({...f,satis_fiyati:e.target.value}))} />
          </div>
          {!kalem && (
            <div className="form-group">
              <label className="form-label">Başlangıç Stok</label>
              <input className="form-input" type="number" value={form.stok_miktari} onChange={e=>setForm(f=>({...f,stok_miktari:e.target.value}))} />
            </div>
          )}
          <div className="form-group">
            <label className="form-label">Kritik Stok</label>
            <input className="form-input" type="number" value={form.kritik_stok} onChange={e=>setForm(f=>({...f,kritik_stok:e.target.value}))} />
          </div>
          <div className="form-group">
            <label className="form-label">Ürün Kodu</label>
            <input className="form-input" value={form.kod} onChange={e=>setForm(f=>({...f,kod:e.target.value}))} placeholder="KIT-TYT-01" />
          </div>
        </div>
        <div style={{display:'flex',justifyContent:'flex-end',gap:10,marginTop:16}}>
          <button className="btn btn-secondary" onClick={onClose}>İptal</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
            {saving ? <div className="spinner" style={{width:16,height:16}} /> : '💾 Kaydet'}
          </button>
        </div>
      </div>
    </div>
  );
}

function HareketiModal({ kalem, ogrenciler, onSave, onClose }) {
  const [form, setForm] = useState({ tip:'giris', miktar:'1', birim_fiyat: kalem?.birim_maliyet||'', aciklama:'', ogrenci_id:'' });
  const [saving, setSaving] = useState(false);
  const handleSubmit = async () => {
    if (!form.miktar) { toast.error('Miktar zorunlu'); return; }
    setSaving(true);
    try { await onSave({ ...form, kalem_id: kalem.id }); } finally { setSaving(false); }
  };
  const TIP_RENK = { giris:'#10B981', cikis:'#EF4444', satis:'#F59E0B', iade:'#3B82F6', sayim:'#8B5CF6' };
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <style>{mobileStyles}</style>
      <div className="modal" style={{maxWidth:440, width:'100%'}} onClick={e=>e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">📦 Stok Hareketi — {kalem?.ad}</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div style={{display:'flex',flexDirection:'column',gap:12}}>
          <div className="form-group">
            <label className="form-label">Hareket Tipi</label>
            <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
              {[['giris','📥 Giriş'],['cikis','📤 Çıkış'],['satis','🛒 Satış'],['iade','↩️ İade'],['sayim','🔢 Sayım']].map(([v,l]) => (
                <button key={v} className={`chip ${form.tip===v?'active':''}`}
                  style={form.tip===v?{background:TIP_RENK[v]+'22',color:TIP_RENK[v],borderColor:TIP_RENK[v], flex:'1 0 30%', textAlign:'center'}:{flex:'1 0 30%', textAlign:'center'}}
                  onClick={()=>setForm(f=>({...f,tip:v,birim_fiyat:v==='satis'?kalem?.satis_fiyati||'':v==='giris'?kalem?.birim_maliyet||'':f.birim_fiyat}))}>
                  {l}
                </button>
              ))}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Miktar ({kalem?.birim||'adet'})</label>
            <input className="form-input" type="number" value={form.miktar} onChange={e=>setForm(f=>({...f,miktar:e.target.value}))} />
          </div>
          <div className="form-group">
            <label className="form-label">Birim Fiyat (₺)</label>
            <input className="form-input" type="number" value={form.birim_fiyat} onChange={e=>setForm(f=>({...f,birim_fiyat:e.target.value}))} />
          </div>
          {form.tip === 'satis' && (
            <div className="form-group">
              <label className="form-label">Öğrenci (satış için)</label>
              <select className="form-input" value={form.ogrenci_id} onChange={e=>setForm(f=>({...f,ogrenci_id:e.target.value}))}>
                <option value="">— Seçin —</option>
                {ogrenciler.map(o => <option key={o.id} value={o.id}>{o.ad} {o.soyad}</option>)}
              </select>
            </div>
          )}
          <div className="form-group">
            <label className="form-label">Açıklama</label>
            <input className="form-input" value={form.aciklama} onChange={e=>setForm(f=>({...f,aciklama:e.target.value}))} />
          </div>
          {form.miktar && form.birim_fiyat && (
            <div style={{padding:'10px 14px',background:'var(--bg-elevated)',borderRadius:10,fontFamily:'var(--font-ui)',fontWeight:800,color:'var(--blue)', textAlign:'center'}}>
              Toplam: {TL(parseFloat(form.miktar)*parseFloat(form.birim_fiyat))}
            </div>
          )}
        </div>
        <div style={{display:'flex',justifyContent:'flex-end',gap:10,marginTop:16}}>
          <button className="btn btn-secondary" onClick={onClose}>İptal</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
            {saving ? <div className="spinner" style={{width:16,height:16}} /> : '💾 Kaydet'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function StokPage() {
  const [kalemler, setKalemler]     = useState([]);
  const [hareketler, setHareketler] = useState([]);
  const [ogrenciler, setOgrenciler] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [kalemModal, setKalemModal] = useState(null);
  const [harModal, setHarModal]     = useState(null);
  const [tab, setTab]               = useState('stok');
  const [filtre, setFiltre]         = useState({ kategori:'', dusuk_stok:'0' });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams(Object.fromEntries(Object.entries(filtre).filter(([,v])=>v && v!=='0')));
      const r = await axios.get(`/muhasebe/stok?${params}`);
      if (r.data.success) setKalemler(r.data.data);
    } catch {} finally { setLoading(false); }
  }, [filtre]);

  const loadHareketler = useCallback(async () => {
    try {
      const r = await axios.get('/muhasebe/stok/hareketler?limit=50');
      if (r.data.success) setHareketler(r.data.data);
    } catch {}
  }, []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { if (tab==='hareketler') loadHareketler(); }, [tab, loadHareketler]);
  useEffect(() => {
    axios.get('/ogrenciler').then(r => { if(r.data.success) setOgrenciler(r.data.data||[]); }).catch(()=>{});
  }, []);

  const handleKalemSave = async (form) => {
    try {
      if (form.id) await axios.put(`/muhasebe/stok/${form.id}`, form);
      else         await axios.post('/muhasebe/stok', form);
      toast.success(form.id ? 'Güncellendi' : 'Eklendi');
      setKalemModal(null); load();
    } catch (e) { toast.error(e.response?.data?.message || 'Hata'); }
  };

  const handleHareket = async (form) => {
    try {
      await axios.post('/muhasebe/stok/hareket', form);
      toast.success('Hareket kaydedildi');
      setHarModal(null); load(); loadHareketler();
    } catch (e) { toast.error(e.response?.data?.message || 'Hata'); }
  };

  const dusukStoklar = kalemler.filter(k => parseFloat(k.stok_miktari||k.hesaplanan_stok||0) <= parseFloat(k.kritik_stok||0));
  const TIP_RENK = { giris:'#10B981', cikis:'#EF4444', satis:'#F59E0B', iade:'#3B82F6', sayim:'#8B5CF6' };
  const TIP_ETIKET = { giris:'📥 Giriş', cikis:'📤 Çıkış', satis:'🛒 Satış', iade:'↩️ İade', sayim:'🔢 Sayım' };

  return (
    <div style={{display:'flex',flexDirection:'column',gap:20, padding: '0 10px'}}>
      <style>{mobileStyles}</style>
      <div className="section-header animate-fadeInUp" style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
        <div>
          <h2 style={{fontFamily:'var(--font-ui)',fontWeight:900, margin:0}}>📦 Stok Yönetimi</h2>
          <div className="section-subtitle">
            {kalemler.length} ürün
            {dusukStoklar.length > 0 && <span style={{color:'#EF4444',fontWeight:700}}> · ⚠️ {dusukStoklar.length} kritik</span>}
          </div>
        </div>
        <button className="btn btn-primary" onClick={()=>setKalemModal('yeni')}>+ Yeni Ürün</button>
      </div>

      {dusukStoklar.length > 0 && (
        <div style={{background:'#FEF3C7',border:'1.5px solid #F59E0B',borderRadius:12,padding:'12px 16px',display:'flex',gap:12,alignItems:'center'}}>
          <span style={{fontSize:'1.3rem'}}>⚠️</span>
          <div style={{flex:1}}>
            <div style={{fontWeight:700,color:'#92400E', fontSize:'0.9rem'}}>Kritik Stok Uyarısı</div>
            <div style={{fontSize:'0.75rem',color:'#92400E', maxWidth: '200px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>
              {dusukStoklar.map(k=>k.ad).join(', ')}
            </div>
          </div>
          <button className="btn btn-sm" style={{background:'#F59E0B',color:'white',border:'none'}}
            onClick={()=>setFiltre(f=>({...f,dusuk_stok:'1'}))}>Gör</button>
        </div>
      )}

      <div className="tab-container" style={{display:'flex',gap:8}}>
        {[{k:'stok',l:'📦 Stok Listesi'},{k:'hareketler',l:'📋 Hareketler'}].map(t => (
          <button key={t.k} className="btn"
            style={{background:tab===t.k?'var(--blue)':'var(--bg-elevated)',color:tab===t.k?'white':'var(--text-secondary)',border:`1.5px solid ${tab===t.k?'var(--blue)':'var(--border)'}`,fontWeight:700}}
            onClick={()=>setTab(t.k)}>{t.l}</button>
        ))}
      </div>

      {tab === 'stok' && (
        <>
          <div className="card filter-bar" style={{padding:'10px 14px',display:'flex',gap:12,alignItems:'center'}}>
            <select className="form-input" style={{width:180,height:36}} value={filtre.kategori}
              onChange={e=>setFiltre(f=>({...f,kategori:e.target.value}))}>
              <option value="">Tüm Kategoriler</option>
              {Object.entries(KAT).map(([v,k])=><option key={v} value={v}>{k.icon} {k.label}</option>)}
            </select>
            <label style={{display:'flex',alignItems:'center',gap:6,fontSize:'0.85rem',cursor:'pointer',userSelect:'none', whiteSpace:'nowrap'}}>
              <input type="checkbox" checked={filtre.dusuk_stok==='1'}
                onChange={e=>setFiltre(f=>({...f,dusuk_stok:e.target.checked?'1':'0'}))} />
              Sadece kritik
            </label>
            {(filtre.kategori||filtre.dusuk_stok==='1') && (
              <button className="btn btn-ghost btn-sm" onClick={()=>setFiltre({kategori:'',dusuk_stok:'0'})}>✕</button>
            )}
          </div>

          <div className="card animate-fadeInUp" style={{padding:0, border: 'none', background: 'transparent'}}>
            {loading ? <div className="page-loader" style={{minHeight:200}}><div className="spinner"/></div>
            : kalemler.length===0 ? <div className="empty-state" style={{padding:56, background: 'var(--bg-card)', borderRadius: 12}}><div style={{fontSize:'3rem'}}>📦</div><h3>Stok kalemi yok</h3></div>
            : (
              <div className="table-container">
                <table className="table">
                  <thead><tr><th>Ürün</th><th>Kategori</th><th>Birim</th><th style={{textAlign:'center'}}>Stok</th><th>Kritik</th><th style={{textAlign:'right'}}>Maliyet</th><th style={{textAlign:'right'}}>Satış</th><th>İşlem</th></tr></thead>
                  <tbody>
                    {kalemler.map((k,i) => {
                      const stok = parseFloat(k.stok_miktari||0);
                      const kritik = parseFloat(k.kritik_stok||0);
                      const dusuk = stok <= kritik;
                      return (
                        <tr key={i} style={{borderLeft:`4px solid ${dusuk?'#EF4444':'transparent'}`}}>
                          <td data-label="Ürün">
                            <div style={{fontWeight:700, textAlign: 'right'}}>{k.ad}</div>
                            {k.kod && <div style={{fontSize:'0.72rem',color:'var(--text-muted)'}}>{k.kod}</div>}
                          </td>
                          <td data-label="Kategori">
                            <span style={{display:'flex',alignItems:'center',gap:5,fontSize:'0.82rem'}}>
                              <span>{KAT[k.kategori]?.icon||'📦'}</span>
                              <span>{KAT[k.kategori]?.label||k.kategori}</span>
                            </span>
                          </td>
                          <td data-label="Birim" style={{color:'var(--text-muted)',fontSize:'0.82rem'}}>{k.birim}</td>
                          <td data-label="Stok" style={{textAlign:'center'}}>
                            <span style={{
                              fontFamily:'var(--font-ui)',fontWeight:900,fontSize:'1.1rem',
                              color:dusuk?'#EF4444':'#10B981'
                            }}>{stok}</span>
                            {dusuk && <span style={{fontSize:'0.65rem',color:'#EF4444', marginLeft: 5}}>⚠️ Düşük</span>}
                          </td>
                          <td data-label="Kritik" style={{color:'var(--text-muted)',fontSize:'0.85rem'}}>{kritik}</td>
                          <td data-label="Maliyet" style={{textAlign:'right',color:'var(--text-muted)'}}>{TL(k.birim_maliyet)}</td>
                          <td data-label="Satış" style={{textAlign:'right',fontWeight:700,color:'#10B981'}}>{k.satis_fiyati>0?TL(k.satis_fiyati):'—'}</td>
                          <td data-label="İşlem">
                            <div className="mobile-actions" style={{display:'flex',gap:6}}>
                              <button className="btn btn-primary btn-sm" onClick={()=>setHarModal(k)}>📦 Hareket</button>
                              <button className="btn btn-ghost btn-sm" onClick={()=>setKalemModal(k)}>✏️ Düzenle</button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </>
      )}

      {tab === 'hareketler' && (
        <div className="card animate-fadeInUp" style={{padding:0, border: 'none', background: 'transparent'}}>
          {hareketler.length===0 ? <div className="empty-state" style={{padding:56, background: 'var(--bg-card)', borderRadius: 12}}><h3>Hareket yok</h3></div>
          : (
            <div className="table-container">
              <table className="table">
                <thead><tr><th>Tarih</th><th>Ürün</th><th>Tip</th><th style={{textAlign:'center'}}>Miktar</th><th style={{textAlign:'right'}}>Toplam</th><th>Açıklama</th><th>Kaydeden</th></tr></thead>
                <tbody>
                  {hareketler.map((h,i)=>(
                    <tr key={i} style={{borderLeft:`4px solid ${TIP_RENK[h.tip]||'#94A3B8'}`}}>
                      <td data-label="Tarih" style={{fontSize:'0.82rem'}}>{new Date(h.created_at).toLocaleDateString('tr-TR')}</td>
                      <td data-label="Ürün" style={{fontWeight:600,fontSize:'0.875rem'}}>{h.kalem_adi}</td>
                      <td data-label="Tip"><span className="badge" style={{background:(TIP_RENK[h.tip]||'#94A3B8')+'22',color:TIP_RENK[h.tip]||'#94A3B8'}}>{TIP_ETIKET[h.tip]||h.tip}</span></td>
                      <td data-label="Miktar" style={{textAlign:'center',fontFamily:'var(--font-ui)',fontWeight:800}}>{h.miktar} {h.birim}</td>
                      <td data-label="Toplam" style={{textAlign:'right',fontFamily:'var(--font-ui)',fontWeight:800,color:TIP_RENK[h.tip]}}>{h.toplam_tutar>0?TL(h.toplam_tutar):'—'}</td>
                      <td data-label="Açıklama" style={{fontSize:'0.78rem',color:'var(--text-muted)'}}>{h.aciklama||h.ogrenci_adi||'—'}</td>
                      <td data-label="Kaydeden" style={{fontSize:'0.78rem',color:'var(--text-muted)'}}>{h.kaydeden_ad}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {kalemModal && <KalemModal kalem={kalemModal==='yeni'?null:kalemModal} onSave={handleKalemSave} onClose={()=>setKalemModal(null)} />}
      {harModal   && <HareketiModal kalem={harModal} ogrenciler={ogrenciler} onSave={handleHareket} onClose={()=>setHarModal(null)} />}
    </div>
  );
}